var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table rate-table" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _c("tr", [
            _vm._m(1),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.config.site_name))]),
          ]),
          _vm._v(" "),
          _vm.reservation.date_pickup !== null &&
          _vm.reservation.date_return !== null
            ? _c("tr", [
                _vm._m(2),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.rental_dates_formatted))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$store.state.model.reservation.group_link_id &&
          _vm.do_not_show_price_on_checkout != 1 &&
          !(
            _vm.$store.state.model.reservation._type == "advance" &&
            !_vm.$store.state.model.reservation.is_seasonal &&
            _vm.no_priceing_checkouts == 1
          )
            ? [
                !_vm.is_prepay
                  ? _c("tr", [
                      _c("td", [
                        _c("strong", [
                          _vm._v("Ski Rental"),
                          _vm.reservation.date_pickup !== null &&
                          _vm.reservation.date_return !== null
                            ? _c("span", [
                                _vm._v(
                                  " (" + _vm._s(_vm.rental_timespan) + ")"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(":"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.frontend_view_folder == "frontend.winterpark"
                        ? _c("td", [
                            _vm._v(
                              _vm._s(_vm._money(_vm.toalPriceWithoutDiscount))
                            ),
                          ])
                        : _c("td", [
                            _vm.showPriceWithoutDiscount
                              ? _c("span", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm._money(
                                          _vm.cost
                                            .packages_price_without_discounts
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.$store.state.resources.config
                                    .module_type == "module_19" &&
                                  _vm.getNoChargeOnSundayMessage() !== ""
                                    ? _c(
                                        "span",
                                        { staticClass: "error--text" },
                                        [
                                          _vm._v(
                                            "\n                        (" +
                                              _vm._s(
                                                _vm.getNoChargeOnSundayMessage()
                                              ) +
                                              ").\n                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm._money(
                                          _vm.cost.total_packages_price
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.cost.discount && _vm.cost.discount > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "error--text" },
                                        [
                                          _vm._v(
                                            "(-" +
                                              _vm._s(_vm.cost.discount + "%") +
                                              " Discount)"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$store.state.resources.config
                                    .module_type == "module_19" &&
                                  _vm.getNoChargeOnSundayMessage() !== ""
                                    ? _c(
                                        "span",
                                        { staticClass: "error--text" },
                                        [
                                          _vm._v(
                                            "\n                        (" +
                                              _vm._s(
                                                _vm.getNoChargeOnSundayMessage()
                                              ) +
                                              ").\n                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                          ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.is_prepay
                  ? _c("tr", [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("td", [
                        _vm.showPriceWithoutDiscount
                          ? _c(
                              "span",
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._money(
                                        _vm.cost.addons_price_without_discounts
                                      )
                                    ) +
                                    "\n                    "
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ml-2",
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.showAddonsModal = true
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-information-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("span", [
                              _vm._v(
                                _vm._s(_vm._money(_vm.cost.total_addon_price))
                              ),
                            ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_buddy_service_enabled &&
                _vm.cost.total_addon_price_buddy_insurance &&
                !_vm.is_prepay
                  ? _c("tr", [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm._money(
                              _vm.cost.total_addon_price_buddy_insurance
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.is_prepay &&
                _vm.cost.special_days_amount &&
                _vm.$store.state.resources.config.module_type != "module_19"
                  ? _c("tr", [
                      _c("td", [
                        _c("strong", [
                          _vm._v(
                            "Special period increase ( " +
                              _vm._s(_vm.cost.special_period_days_count) +
                              " Days):"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._money(_vm.cost.special_days_amount))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showPriceWithoutDiscount
                  ? [
                      !_vm.is_prepay
                        ? _c("tr", [
                            _vm._m(5),
                            _vm._v(" "),
                            _vm.frontend_view_folder == "frontend.winterpark"
                              ? _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._money(
                                        _vm.toalPriceWithoutDiscount +
                                          _vm.cost.total_addon_price
                                      )
                                    )
                                  ),
                                ])
                              : _c("td", [
                                  _vm._v(
                                    _vm._s(_vm._money(_vm.cost.sub_total))
                                  ),
                                ]),
                          ])
                        : _c("tr", [
                            _vm._m(6),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.total_without_discount)),
                            ]),
                          ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.reservation.is_delivery ||
                (_vm.reservation.is_delivery &&
                  _vm.config.remove_from_front_end_discount == "0")
                  ? [
                      _vm.reservation.is_delivery &&
                      _vm.config.remove_from_front_end_discount == "0" &&
                      _vm.cost.discount !== 0
                        ? [
                            _c("tr", [
                              _vm._m(7),
                              _vm._v(" "),
                              _c("td", { staticClass: "red--text" }, [
                                _vm._v(
                                  _vm._s(_vm._money(_vm.cost.advance_discount))
                                ),
                              ]),
                            ]),
                          ]
                        : [
                            !_vm.is_prepay &&
                            _vm.cost.book_me_discount &&
                            _vm.cost.book_me_discount.discount > 0
                              ? _c("tr", [
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.cost.book_me_discount.name) +
                                          " Discount(" +
                                          _vm._s(
                                            _vm.cost.book_me_discount.percentage
                                          ) +
                                          "%):"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "red--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._money(
                                          _vm.cost.book_me_discount.discount
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : !_vm.is_prepay && _vm.cost.saved_by_coupon > 0
                              ? _c("tr", [
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        "Discount ( " +
                                          _vm._s(_vm.cost.coupon_info.name) +
                                          " " +
                                          _vm._s(
                                            _vm.cost.coupon_info.discount
                                          ) +
                                          " ):"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "red--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._money(_vm.cost.saved_by_coupon)
                                      )
                                    ),
                                  ]),
                                ])
                              : !_vm.is_prepay &&
                                _vm.cost.advance_discount > 0 &&
                                _vm.frontend_view_folder == "frontend.demo" &&
                                _vm.$store.state.resources.config.module_type ==
                                  "module_1"
                              ? _c("tr", [
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        "Discount:\n                        "
                                      ),
                                      _vm.cost.advance_discount_days_count > 0
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                            (" +
                                                _vm._s(_vm.cost.discount) +
                                                "% for " +
                                                _vm._s(
                                                  _vm.cost
                                                    .advance_discount_days_count
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.cost
                                                    .advance_discount_days_count >
                                                    1
                                                    ? "Days"
                                                    : "Day"
                                                ) +
                                                ")\n                        "
                                            ),
                                          ])
                                        : _vm.cost.discount > 0
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                            ( " +
                                                _vm._s(_vm.cost.discount) +
                                                "% )\n                        "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "red--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._money(_vm.cost.advance_discount)
                                      )
                                    ),
                                  ]),
                                ])
                              : !_vm.is_prepay &&
                                _vm.cost.advance_discount > 0 &&
                                _vm.config.module_type_enabled != 0 &&
                                (_vm.config.module_type == "module_11" ||
                                  _vm.config.module_type == "module_15")
                              ? _c("tr", [
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        "Discount:\n                        "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          "\n                            ( " +
                                            _vm._s(_vm.cost.discount) +
                                            "% )\n                        "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "red--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._money(_vm.cost.advance_discount)
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm.is_prepay && _vm.prepay_discount != "$0.00"
                              ? _c("tr", [
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "red--text" }, [
                                    _vm._v(_vm._s(_vm.prepay_discount)),
                                  ]),
                                ])
                              : _vm.discountType == "percentage" &&
                                _vm.frontend_view_folder ==
                                  "frontend.winterpark"
                              ? _c("tr", [
                                  _vm._m(9),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "red--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._money(
                                          _vm.toalPriceWithoutDiscount -
                                            _vm.cost.total_packages_price
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm.discountType == "fix_amount" &&
                                _vm.frontend_view_folder ==
                                  "frontend.winterpark"
                              ? _c("tr", [
                                  _vm._m(10),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "red--text" }, [
                                    _vm._v(_vm._s(_vm._money(_vm.fixDiscount))),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPriceWithoutDiscount
                  ? [
                      !_vm.is_prepay
                        ? _c("tr", [
                            _vm._m(11),
                            _vm._v(" "),
                            _vm.frontend_view_folder == "frontend.winterpark"
                              ? _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._money(
                                        _vm.toalPriceWithoutDiscount +
                                          _vm.cost.total_addon_price
                                      )
                                    )
                                  ),
                                ])
                              : _c("td", [
                                  _vm._v(
                                    _vm._s(_vm._money(_vm.cost.sub_total))
                                  ),
                                ]),
                          ])
                        : _c("tr", [
                            _vm._m(12),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.total_without_discount)),
                            ]),
                          ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_international_canadian
                  ? [
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              "Tax: ( PST: " + _vm._s(_vm.sales_tax_pst) + "% )"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm._money(_vm.cost.pst_tax_amount))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              "Tax: ( GST: " + _vm._s(_vm.sales_tax_gst) + "% )"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm._money(_vm.cost.gst_tax_amount))),
                        ]),
                      ]),
                    ]
                  : [
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v("\n                        Taxes: "),
                            !_vm.is_prepay
                              ? _c("span", [
                                  _vm._v(
                                    "( " + _vm._s(_vm.cost.tax_percent) + "% )"
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "( " +
                                      _vm._s(_vm.prepay_tax_percent) +
                                      "% )"
                                  ),
                                ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        !_vm.is_prepay
                          ? _c("td", [
                              _vm._v(_vm._s(_vm._money(_vm.cost.tax_amount))),
                            ])
                          : _c("td", [_vm._v(_vm._s(_vm.prepay_sales_tax))]),
                      ]),
                    ],
                _vm._v(" "),
                parseInt(_vm.config.special_fee_at_checkout) == 1
                  ? _c("tr", [
                      _c("td", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.config.special_fee_label) + ":"),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.is_prepay
                        ? _c("td", [
                            _vm._v(_vm._s(_vm._money(_vm.cost.special_fee))),
                          ])
                        : _c("td", [
                            _vm._v(_vm._s(_vm._money(_vm.prepay_special_fee))),
                          ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.is_prepay
                  ? _c("tr", [
                      _c("td", [
                        _c("strong", [
                          _vm._v("Total Cost"),
                          !isNaN(_vm.rental_timespan)
                            ? _c("span", [
                                _vm._v(
                                  " (" + _vm._s(_vm.rental_timespan) + ")"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(":"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._money(_vm.cost.total_price))),
                      ]),
                    ])
                  : _c("tr", [
                      _vm._m(13),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._money(_vm.prepay_total_price))),
                      ]),
                    ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "700px" },
          model: {
            value: _vm.showAddonsModal,
            callback: function ($$v) {
              _vm.showAddonsModal = $$v
            },
            expression: "showAddonsModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v("Add-on Details"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showAddonsModal = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-simple-table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticClass: "text-left" }, [
                          _vm._v("Add-on"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-left" }, [
                          _vm._v("Price"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-left" }, [
                          _vm._v("Coupon Discount"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-left" }, [
                          _vm._v("Taxable"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.selectedAddons, function (addon, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [_vm._v(_vm._s(addon.title))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(addon.price))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(addon.discountable ? "Yes" : "No")),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(addon.taxable ? "Yes" : "No")),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Rental Information")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { width: "35%" } }, [
      _c("strong", [_vm._v("Rental Location:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Rental Dates:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Add-on Total:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Buddy Price:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Sub Total:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Sub Total:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Discount:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Discount:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Discount:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Discount:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Sub Total:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Sub Total:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Total To Be Paid:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }